import { createRouter, createWebHistory } from "vue-router";
import MyLogin from "./pages/MyLogin.vue";
import MyHome from "./pages/MyHome.vue";
import MyOa from "./pages/MyOa.vue";
import MySearch from "./pages/MySearch.vue";
import MyAbout from "@/components/home/MyAbout.vue";
import MyRegister from "./pages/MyRegister.vue";
import MyRegProfile from "./pages/MyRegProfile.vue";
import CreateOA from "./pages/CreateOA.vue";

import store from "./store";
import MyProfile from "./pages/MyProfile.vue";

const routes = [
  {
    path: "/",
    name: "myHome",
    component: MyHome,
  },

  {
    path: "/login",
    name: "myLogin",
    component: MyLogin,
  },

  {
    path: "/profile/:id",
    name: "myProfile",
    component: MyProfile,
    meta: { requiresAuth: true },
  },

  {
    path: "/register",
    name: "myRegister",
    component: MyRegister,
  },

  {
    path: "/register-profile",
    name: "myRegProfile",
    component: MyRegProfile,
    meta: { requiresAuth: true },
  },

  {
    path: "/oa/:id",
    name: "myOa",
    component: MyOa,
    props: true, // Allow passing route params as props
  },

  {
    path: "/sobre",
    name: "myAbout",
    component: MyAbout,
  },

  {
    path: "/oas/:searchQuery?",
    name: "mySearch",
    component: MySearch,
    props: true,
  },
  {
    path: "/profile/create-oa",
    name: "create-oa",
    component: CreateOA,
    meta: { requiresAuth: true },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const isAuthenticated = store.getters.isAuthenticated;
  const hasBaoBahUser = store.getters.hasBaoBahUser;

  if (requiresAuth && !isAuthenticated) {
    next({ name: "myLogin" });
  } else if (isAuthenticated && !hasBaoBahUser && to.name !== "myRegProfile") {
    // Se o usuário está autenticado mas não completou o perfil, redireciona para a página de completar perfil
    next({ name: "myRegProfile" });
  } else {
    next();
  }
});

export default router;
